/**
 * Helpers partagés pour la gestion des paramètres de recherche dans l'URL
 * (arrival, departure, nbPers, etc.) sans redirections HTTP.
 */

/**
 * Lit la query string courante et retourne un objet simple.
 */
export function getSearchParamsFromUrl(urlLike = window.location.href) {
    const url = new URL(urlLike, window.location.origin);
    const params = url.searchParams;

    const entries = {};
    for (const [key, value] of params.entries()) {
        entries[key] = value;
    }
    return entries;
}

/**
 * Hydrate un state (store Interactivity) à partir de l'URL.
 * On ne force que les clés existantes dans l'URL pour ne pas écraser
 * les valeurs côté PHP/cookies quand l'URL est « vide ».
 */
export function syncStateFromUrl(state) {
    if (typeof window === 'undefined') return;
    try {
        const url = new URL(window.location.href);
        const params = url.searchParams;

        const arrival = params.get('arrival');
        const departure = params.get('departure');
        const nbPers = params.get('nbPers');

        if (arrival) {
            state.gtArrival = arrival;
        }
        if (departure) {
            state.gtDeparture = departure;
        }
        if (nbPers) {
            state.gtNbPers = nbPers;
        }
    } catch (e) {
        // En environnement sans URL API, on ne fait rien.
    }
}

/**
 * Reconstruit la query string avec encodage de toutes les valeurs
 * (ex: / en %2F dans les dates) pour éviter des effets de bord (Rocket, etc.).
 */
export function buildSearchWithEncodedParams(urlObj) {
    const parts = [];
    for (const [key, value] of urlObj.searchParams.entries()) {
        parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    }
    return parts.join('&');
}

/**
 * Applique l'état courant (dates, nbPers, type, etc.) dans l'URL,
 * via history.pushState / replaceState, sans rechargement de page.
 *
 * @param {object} state - state du store Interactivity (gt/ctv).
 * @param {object} options - { replace?: boolean }
 */
export function updateUrlFromState(state, options = {}) {
    if (typeof window === 'undefined') return;

    const { replace = false } = options;

    try {
        const url = new URL(window.location.href);
        const params = url.searchParams;

        if (state.gtArrival) {
            params.set('arrival', state.gtArrival);
        }
        if (state.gtDeparture) {
            params.set('departure', state.gtDeparture);
        }
        if (state.gtNbPers) {
            params.set('nbPers', state.gtNbPers);
        }

        url.search = buildSearchWithEncodedParams(url);

        const newHref = url.toString();
        if (replace) {
            window.history.replaceState({}, '', newHref);
        } else {
            window.history.pushState({}, '', newHref);
        }
    } catch (e) {
        // On ne casse pas le comportement si l'URL API n'est pas disponible.
    }
}

